<template>
    <div class="c-o-my-pages-section">
        <div class="c-o-my-pages-section__inner">
            <h2 class="c-o-my-pages-section__heading">Kvalitetsäkring</h2>
            <div class="o-wysiwyg u-margin-bottom-2">
                <p>Nedan finns den information om er som vi använder till vår kvalitetssäkring.</p>
                <p>Om ni har frågor eller vill uppdatera era certifikat – kontakta vår kundtjänst (<a href="tel:07344160667">telefon: 010 70 77 379</a> eller maila till <a href="mailto:byggare@brabyggare.se">byggare@brabyggare.se</a>).</p>
            </div>
            <div v-if="quality" class="c-o-my-pages-quality-assurance">
                <div v-if="evaluationDate" class="c-o-my-pages-quality-assurance__diploma">
                    <span class="c-o-my-pages-quality-assurance__diploma-badge">
                        <icon :icon="'check_circle'"></icon>
                    </span>
                    <p class="c-o-my-pages-quality-assurance__diploma-heading">Kontrollerat av BraByggare:</p>
                    <p class="c-o-my-pages-quality-assurance__diploma-date h3">{{evaluationDate | formatDateWithoutTime }}</p>

                </div>
                <h3 class="c-o-my-pages-quality-assurance__details-header">Företagsuppgifter</h3>
                <ul class="c-o-my-pages-quality-assurance__details">
                    <li class="c-o-my-pages-quality-assurance__detail">
                        <span class="c-o-my-pages-quality-assurance__detail-title">Organisationsnummer:</span>
                        {{orgNr}}
                    </li>
                    <li class="c-o-my-pages-quality-assurance__detail">
                        <span class="c-o-my-pages-quality-assurance__detail-title">Innehar F-skattesedel:</span>
                        {{hasTaxReg}}
                    </li>
                    <li class="c-o-my-pages-quality-assurance__detail">
                        <span class="c-o-my-pages-quality-assurance__detail-title">Bransch:</span>
                        {{bransch}}
                    </li>
                    <li class="c-o-my-pages-quality-assurance__detail">
                        <span class="c-o-my-pages-quality-assurance__detail-title">Reg. datum firma:</span>
                        {{regDate | formatDateWithoutTime }}
                    </li>
                    <li class="c-o-my-pages-quality-assurance__detail">
                        <span class="c-o-my-pages-quality-assurance__detail-title">Registrerad för moms:</span>
                        {{hasVatReg}}
                    </li>
                    <li class="c-o-my-pages-quality-assurance__detail">
                        <span class="c-o-my-pages-quality-assurance__detail-title">Bolagsform:</span>
                        {{typeOfCompany}}
                    </li>
                </ul>
                <h3 class="c-o-my-pages-quality-assurance__details-header">Ansvarsförsäkring och kreditvärdighet</h3>
                <ul class="c-o-my-pages-quality-assurance__details">
                    <li class="c-o-my-pages-quality-assurance__detail">
                        <span class="c-o-my-pages-quality-assurance__detail-title">Ansvarsförsäkring:</span>
                        {{hasInsurance}}
                    </li>
                    <li class="c-o-my-pages-quality-assurance__detail">
                        <span class="c-o-my-pages-quality-assurance__detail-title">Kreditkontroll:</span>
                        {{creditControl}}
                    </li>
                    <li class="c-o-my-pages-quality-assurance__detail">
                        <span class="c-o-my-pages-quality-assurance__detail-title">Försäkringsbolag:</span>
                        {{insuranceCompany}}
                    </li>
                    <li class="c-o-my-pages-quality-assurance__detail">
                        <span class="c-o-my-pages-quality-assurance__detail-title">Bevakas via:</span>
                        {{guarded}}
                    </li>
                </ul>
                <h3 class="c-o-my-pages-quality-assurance__details-header">Svartlistning</h3>
                <ul class="c-o-my-pages-quality-assurance__details">
                    <li class="c-o-my-pages-quality-assurance__detail">
                        <span class="c-o-my-pages-quality-assurance__detail-title">Brabyggare:</span>
                        {{blacklisted}}
                    </li>
                    <li class="c-o-my-pages-quality-assurance__detail">
                        <span class="c-o-my-pages-quality-assurance__detail-title">
                            Råd & Rön (<a target="_blank" :href="'https://www.radron.se/Svarta-listan/'">gå till lista</a>):
                        </span>
                        {{blacklisted}}
                    </li>
                </ul>
            </div>
            <div class="u-margin-top-2">
                <certificates v-if="certificates && certificates.length > 0" :certificates="certificates"></certificates>
                <div v-else>
                    <empty-state :heading="'Inga certifikat att visa'" :icon="null" :body="'<p>Du har inga certifikat tillagda än.<p></p>För att lägga till certifikat, kontakta vår kundtjänst.</p>'"></empty-state>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Filters from '../../../../../../filters/index.js'

    import Certificates from '../../../../molecules/MoleculeCertificates.vue'
    import EmptyState from '../../../../molecules/MoleculeEmptyState.vue'
    import Icon from '../../../../atoms/AtomIcon.vue'
    import ButtonLink from '../../../../atoms/AtomButtonLinkExternal.vue'

    export default {
        props: {
            orgNr: String|Number,
            quality: Object,
            certificates: Array
        },
        components: {
            Icon,
            ButtonLink,
            EmptyState,
            Certificates
        },
        filters: Filters,
        computed: {
            evaluationDate: function() {
                return this.quality.EvaluationDate
            },
            hasTaxReg: function() {
                return this.quality.HasTaxRegistration ? 'Ja' : 'Nej'
            },
            bransch: function() {
                return this.quality.Branch
            },
            regDate: function() {
                return this.quality.RegistrationDate
            },
            hasVatReg: function() {
                return this.quality.HasVATRegistration ? 'Ja' : 'Nej'
            },
            typeOfCompany: function() {
                return this.quality.CompanyForm
            },
            hasInsurance: function() {
                return this.quality.HasInsurance ? 'Ja' : 'Uppgift saknas'
            },
            creditControl: function() {
                return 'Kredit bevakas löpande, stängs av vid betalningsproblem'
            },
            insuranceCompany: function() {
                return this.quality.InsuranceCompany
            },
            guarded: function() {
                return 'Creditsafe'
            },
            blacklisted: function() {
                return 'Ej svartlistad'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/my-pages-sections/company/profile/OrganismMyPagesQualityAssurance.vue